import {NamedTranslation} from "./locale";
import {License} from "./src/license";

export class Config {

  constructor(
    public sitekey: string,
    public privacyUrl: string,
    public trustcaptchaUrl: string,
    public trustcaptchaApi: string,
    public framework: string | null,
    public language: string,
    public theme: 'light' | 'dark' | 'media',
    public currentTheme: 'light' | 'dark',
    public autostart: boolean,
    public tokenFieldName: string,
    public bypassToken: string | null,
    public mode: 'standard' | 'minimal',
    public translation: NamedTranslation,
    public hideBranding: boolean,
    public invisible: boolean,
    public licenseObject?: License,
  ) {}
}
